import React from "react";
import CustomButton from "./common/CustomButton";
import VitalityCard from "./common/VitalityCard";

const VitalityBoxCards = ({ offerCardsRef }) => {
  const handleScroll = () => {
    offerCardsRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  const cardData = [
    {
      psTitle: "P.S. This is a once-in-a-lifetime offer.",
      texts: [
        {
          text: "As I mentioned, The Vitality Box is only available to the first 200 people who claim it.",
        },
        {
          text: "Once it’s gone, it’s gone. So, don’t miss your chance to experience a surge in renewed vitality, health, and energy - absolutely free.",
        },
        { text: "Click below to claim your free VIP gift now!", center: true },
      ],
    },
    {
      psTitle:
        "P.PS. Look, I know how trying something new can feel like a big “risk”.",
      texts: [
        {
          text: "But I want you to feel 100% confident and at peace with your decision.",
        },
        { text: "That’s why you’re getting a 90-day money-back guarantee." },
        {
          text: "If you’re not completely satisfied with your results, just let us know, and we’ll refund every penny.",
        },
        { text: "We’re easy to get a hold of." },
        { text: "No questions, no hassle — just peace of mind." },
        { text: "Click below now to claim your FREE Vitality Box." },
        {
          text: "You’ll be feeling and looking your best before you know it.",
          center: false,
        },
      ],
    },
  ];

  return (
    <div className="my-10">
      <div className="main-container mx-auto text-center mx-6">
        <p className="mt-6 text-[#B91111] font-bold text-[20px] text-center px-16 bold-font">
          Remember, Due To Limited Discounted Vitality Boxes…
        </p>
        <p className="mt-6 text-[#000000] font-normal text-[20px] text-center px-3">
          Once You Exit This Page You Cannot Come Back Here To Take Advantage Of
          This Offer!
        </p>
        <p className="mt-6 text-[#000000] font-normal text-[20px] text-center px-3">
          This is only being offered to our NEW buyers of Lung Renew. So take
          advantage now.
        </p>
        <p className="mt-6 text-[#000000] font-bold text-[20px] text-center bold-font px-3">
          Click the yellow button above to accept your Discounted Vitality Box.
        </p>

       {cardData.map((card, index) => (
          <VitalityCard
            key={index}
            psTitle={card.psTitle}
            texts={card.texts}
            onClick={handleScroll}
          />
        ))}
      </div>
    </div>
  );
};

export default VitalityBoxCards;
